{
	"common": {
		"actions": "Actions",
		"add": "Add",
		"close": "Close",
		"backToPlanvera": "Back to PlanVera",
		"cancel": "Cancel",
		"description": "Description",
		"export": "Export",
		"filter": "Filter {{column}}",
		"import": "Import",
		"name": "Name",
		"open": "Open",
		"quantity": "Quantity",
		"returnToPlanvera": "Return to PlanVera",
		"save": "Save",
		"scale": "Scale",
		"signOut": "Sign out",
		"unit": "Unit"
	},
	"units": {
		"C62": "pcs",
		"XPK": "pkt"
	},
	"sidebar": {
		"collapse": "Collapse menu",
		"expand": "Expand menu",
		"files": "Files",
		"language": "Language",
		"openNavigation": "Open navigation",
		"products": "Products",
		"quantityList": "Quantity list",
		"takeoffs": "Takeoffs",
		"trash": "Trash",
		"workPackages": "Work packages"
	},
	"takeoffList": {
		"confirmDelete": "Move Takeoff \"{{name}}\" to the trash?",
		"confirmPermanentDelete": "Permanently delete \"{{name}}\"? All measurements and data will be destroyed. This cannot be undone.",
		"create": "Create Takeoff",
		"delete": "Delete",
		"deletedOn": "Deleted {{date}}",
		"permanentDelete": "Delete permanently",
		"restore": "Restore",
		"trash": "Trash",
		"trashEmpty": "The trash is empty.",
		"descriptionLabel": "Description",
		"descriptionPlaceholder": "Description (optional)",
		"disciplineLabel": "Discipline",
		"discipline": {
			"electrical": "electrical",
			"other": "other",
			"plumbing": "plumbing"
		},
		"duplicating": "Duplicating…",
		"emptyCta": "Create takeoff",
		"emptyDescription": "Create your first takeoff to start counting quantities.",
		"emptyTitle": "No takeoffs yet",
		"fileCount": "{{count}} files",
		"locked": "Locked · {{count}} inaccessible files",
		"title": "Takeoffs"
	},
	"frontpage": {
		"addFile": "Add file",
		"confirmDetachBody": "This permanently deletes all Entries, targets, and measurement data for {{name}} from this Takeoff. This cannot be undone.",
		"deleteData": "Delete data",
		"detachAndDelete": "Detach and delete data",
		"editDescription": "Edit description",
		"editScale": "Edit scale",
		"files": "Files",
		"groupAttached": "Attached",
		"groupDetached": "Detached — data retained",
		"groupTrashed": "Trashed",
		"lockedNotice": "This Takeoff is temporarily locked while File data is purged or access is re-synchronized. It retries automatically — reload the page in a minute.",
		"noFiles": "No Files in this Takeoff yet. Add drawings or IFC models to start measuring.",
		"quantityList": "Quantity list",
		"quantityTakeoff": "Quantity takeoff",
		"reattach": "Reattach",
		"removeRetainedData": "Remove retained data",
		"workPackages": "Work packages"
	},
	"flow": {
		"archivedReadOnly": "Archived project — read only",
		"collapseExport": "Collapse rows on export",
		"exportDialogTitle": "Export quantity list",
		"exportFilenameLabel": "File name",
		"locked": "Takeoff locked",
		"lockedDescription": "Access is pending authorization synchronization or a retained File is inaccessible."
	},
	"quantityTable": {
		"code": "Package ID / sähkönumero",
		"collapseAll": "Collapse all rows",
		"deleteRow": "Delete row",
		"expandAll": "Expand all rows",
		"editRow": "Edit row",
		"empty": "Nothing measured and targeted yet.",
		"mainProduct": "Main product",
		"measurements": "Measurements",
		"measurementLabel": "Measurement {{index}}",
		"segmentLabel": "Segment {{index}}",
		"contents": "Contents",
		"type": "Type",
		"typeTask": "Task",
		"typeProduct": "Product",
		"products": "Products",
		"showDetails": "Show package details",
		"showInViewer": "Show in viewer",
		"system": "System",
		"tasks": "Tasks",
		"classifySelection": "Classify ({{count}})",
		"selectAll": "Select all rows",
		"classification": "Classification",
		"classificationFilter": "Filter by classification"
	},
	"browser": {
		"allPackages": "All packages",
		"basicInfo": "Package details",
		"code": "Code",
		"date": "Date",
		"emptyGroup": "No packages in this group.",
		"groupTree": "Package groups",
		"groups": "Groups",
		"installationInfo": "Installation details",
		"modified": "Modified",
		"name1": "Name 1",
		"name2": "Name 2",
		"noChildPackages": "No linked packages",
		"ownPackages": "Own packages",
		"ungrouped": "Ungrouped",
		"editMode": "Edit",
		"addPackage": "Add package",
		"editGroups": "Edit groups",
		"addGroup": "Add group",
		"addSubgroup": "Add subgroup",
		"editGroup": "Edit group",
		"deleteGroup": "Delete group",
		"confirmDeleteGroup": "Delete this empty group permanently?",
		"groupCode": "Group code (optional)",
		"parentGroup": "Parent group",
		"confirmMoveTitle": "Move package",
		"confirmMovePackage": "Move {{package}} to {{group}}?",
		"movePackage": "Move",
		"packageUnit": "Package unit",
		"quantity": "Quantity",
		"sahkonro": "El. no.",
		"searchPlaceholder": "Search by name, code or product number…",
		"sectionMainProducts": "Main products ({{count}})",
		"sectionPackages": "Packages ({{count}})",
		"sectionProducts": "Products ({{count}})",
		"sectionWorks": "Works ({{count}})",
		"toggleGroup": "Expand or collapse group",
		"tyonro": "Work no.",
		"variantCount": "Installation methods",
		"createDialogIntro": "A package is a list of task and product rows consumed per one basis unit.",
		"createPackage": "Create package",
		"createTitle": "Create WorkPackage",
		"addProductRow": "Add product row",
		"addTaskRow": "Add task row",
		"basisUnit": "Basis unit",
		"group": "Group",
		"importResult": "Imported {{packages}} packages, {{versions}} new versions.",
		"importResultPlaceholders": "{{count}} placeholder products created (Sähkönumerot sync fills in real names later).",
		"installation": "Installation",
		"newPackage": "New package",
		"noPackages": "No packages in the catalog yet.",
		"noRows": "No rows yet.",
		"packageCode": "Package ID",
		"packageCodeOptional": "Optional",
		"packageName": "Package name",
		"product": "Product",
		"removeRow": "Remove row",
		"rowUnit": "Row unit",
		"rowsPerBasisUnit": "Rows (per basis unit)",
		"duplicatePackage": "Duplicate",
		"editPackage": "Edit",
		"editTitle": "Edit work package",
		"selectSubPackage": "Select a package",
		"subPackage": "Sub-package",
		"restorePackage": "Restore",
		"retirePackage": "Retire",
		"searchPackages": "Search packages",
		"searchProducts": "Search products",
		"selectProduct": "Select a product",
		"createProduct": "Create product",
		"loadMore": "Load more",
		"newProduct": "New product",
		"noProducts": "No products found.",
		"productCode": "Product ID",
		"productName": "Product name",
		"productsTitle": "Products",
		"showRetired": "Show retired",
		"source": "Source",
		"sourceOwn": "Own",
		"sourceSahkonumerot": "Sähkönumerot",
		"sourceStul": "STUL",
		"subPackages": "Sub-packages",
		"taskName": "Task name",
		"title": "Work packages",
		"favoritesGroup": "Favourites",
		"favorite": "Favourite"
	},
	"picker": {
		"addFiles_one": "Add {{count}} file",
		"addFiles_other": "Add {{count}} files",
		"alreadyAttached": "Already attached",
		"emptyFolder": "This folder is empty.",
		"folderPath": "Folder path",
		"title": "Add Files to Takeoff"
	},
	"workspace": {
		"loading": "Loading Takeoff…",
		"unavailable": "Takeoff unavailable",
		"unavailableDescription": "Takeoff could not be loaded."
	},
	"viewer": {
		"tools": {
			"navigate": "Navigate",
			"point": "Point measurement",
			"route": "Route measurement",
			"area": "Area measurement",
			"measure": "Measure",
			"navigateShort": "Navigate",
			"pointShort": "Point",
			"routeShort": "Route",
			"areaShort": "Area",
			"measureShort": "Measure"
		},
		"seedMethods": {
			"select": "Select",
			"draw": "Draw"
		},
		"pointModes": {
			"select": "Select",
			"add": "Add points"
		},
		"granularity": {
			"group": "Group select",
			"single": "Single-object select"
		},
		"panel": {
			"expand": "Open panel",
			"collapse": "Collapse panel",
			"selectionLayers": "Selection layers",
			"showAllSelectionLayers": "Show all selection layers",
			"hideAllSelectionLayers": "Hide all selection layers",
			"isolateSelectionLayers": "Show only selection layers",
			"restoreLayers": "Restore layers",
			"showLayer": "Show layer",
			"hideLayer": "Hide layer",
			"showOnlyLayer": "Show only this layer"
		},
		"layers": "Layers",
		"nav": {
			"previousPage": "Previous page",
			"nextPage": "Next page",
			"zoomIn": "Zoom in",
			"zoomOut": "Zoom out",
			"resetView": "Reset view",
			"exit": "Exit"
		},
		"missingScaleWarning": "Drawing scale is not configured. Configure the scale to use measurements.",
		"clearSelection": "Clear selection",
		"clearSelectionHint": "Clear selection (Esc)",
		"scaleDialog": {
			"title": "Set drawing scale",
			"description": "Set a scale for this drawing to start measuring.",
			"editTitle": "Change drawing scale",
			"editDescription": "Choose the correct scale for this drawing.",
			"saveChanges": "Save",
			"recalculateWarning": "Measurements are recalculated with the new scale. Existing quantity takeoff items keep the scale they were created with.",
			"close": "Close scale dialog",
			"scaleLabel": "Scale",
			"scalePlaceholder": "Select scale",
			"customScaleLabel": "Custom scale",
			"customScalePlaceholder": "1:100",
			"customScaleHint": "Use a ratio like 1:100.",
			"scaleUnitLabel": "Scale unit",
			"scaleUnitPlaceholder": "Select unit",
			"save": "Save and measure",
			"saving": "Saving…",
			"saved": "Drawing scale saved",
			"saveError": "Could not save drawing scale",
			"missingScale": "Choose a scale",
			"missingUnit": "Choose a unit",
			"invalidScale": "Scale must use a positive ratio like 1:100"
		},
		"measure": {
			"title": "Measurements",
			"selected": "{{count}} selected",
			"selectAll": "Select all",
			"clearSelection": "Clear selection",
			"clearAll": "Clear all",
			"scale": "Scale: {{scale}} ({{unit}})",
			"scaleMissing": "Scale not configured",
			"editScale": "Change scale",
			"display": "Display",
			"totalArea": "Total area {{value}}",
			"totalLength": "Total length {{value}}",
			"empty": "No measurements yet. Draw on the canvas to add measurements.",
			"locate": "Locate measurement",
			"delete": "Delete measurement",
			"select": "Select {{value}}",
			"deselect": "Deselect {{value}}",
			"color": "Measurement color",
			"newColor": "Color for new measurements",
			"selectionColor": "Selection color",
			"auto": "Auto",
			"autoColor": "Automatic color",
			"customColor": "Custom",
			"hue": "Hue",
			"hex": "Hex color",
			"back": "Back",
			"tools": {
				"distance": "Distance",
				"path": "Path",
				"area": "Area",
				"snap": "Snap",
				"angle": "Angle",
				"clear": "Clear"
			}
		},
		"picker": {
			"title": "Work packages",
			"searchPlaceholder": "Search by name, code, or sähkönumero",
			"root": "All groups",
			"loadMore": "Show more",
			"empty": "No packages found",
			"tabBrowse": "Browse",
			"tabRecents": "Recent",
			"noRecents": "No recently used packages yet",
			"ownGroup": "Own packages",
			"ungroupedGroup": "Ungrouped",
			"incompatibleReason": "Incompatible unit",
			"tabFavorites": "Favourites",
			"noFavorites": "No favourite packages yet — star a package to pin it here",
			"variantCount": "{{count}} methods",
			"variantCount_one": "{{count}} method",
			"favorite": "Favourite"
		},
		"colorMode": {
			"title": "Coloring",
			"package": "By package",
			"category": "By category",
			"classification": "By classification",
			"system": "By system",
			"custom": "Custom colors"
		},
		"area": {
			"added": "Area added",
			"drawHint": "Tap the drawing to outline an area; tap the first vertex to close",
			"quantityLabel": "Quantity",
			"rawLabel": "Measured area",
			"perimeterLabel": "Perimeter",
			"labelLabel": "Label",
			"finish": "Finish area",
			"createMeasurement": "Create measurement",
			"createHint": "Outline closed — press Create measurement to save the area",
			"sectionTitle": "Area measurement"
		},
		"point": {
			"selectHint": "Select one or more symbols on the drawing",
			"addHint": "Tap the drawing to place a point",
			"added": "Point added",
			"addMeasurement": "Add measurement"
		},
		"measurement": {
			"added": "Measurement added",
			"addedCount_one": "{{count}} measurement added",
			"addedCount_other": "{{count}} measurements added",
			"noLineGeometry": "Selection has no line geometry to route"
		},
		"wireRun": {
			"noExtension": "No further run to extend into.",
			"atMinimum": "Wire run is at its minimum.",
			"noConnectedSegments": "No connected wire segments found.",
			"stillLoading": "Drawing is still loading — try again in a moment."
		},
		"autoTune": {
			"tuned": "Selection grouping tuned: {{granularity}} (score {{score}})",
			"nothingToGroup": "Auto-tune found nothing to group on this page.",
			"failed": "Auto-tune failed."
		},
		"entry": {
			"untargetedWarning": "No work package assigned — not counted in the estimate",
			"position": "Position",
			"factor": "Factor",
			"package": "Work package",
			"noPackage": "No package",
			"packageSelected": "Package selected",
			"color": "Custom color",
			"noSystemMatches": "No systems found",
			"delete": "Delete measurement",
			"incompatiblePackage": "This package's unit is not compatible with the measurement"
		},
		"search": {
			"presets": {
				"strict": "Strict",
				"normal": "Normal",
				"loose": "Loose"
			},
			"advanced": "Advanced",
			"minScore": "Match threshold",
			"sizeTolerance": "Size tolerance",
			"run": "Find similar",
			"matchCount": "{{included}} of {{count}} matches included",
			"matchRow": "Match {{index}} · {{score}} %",
			"assignAll": "Add {{count}} measurements",
			"clear": "Clear results",
			"title": "Symbol search"
		},
		"route": {
			"drafting": {
				"draw": "{{count}} points placed — double-click or Finish to complete"
			},
			"pickCable": "Pick cable…",
			"removeSegment": "Remove segment",
			"gapSegment": "Gap",
			"gapSegmentHint": "Not cable: joins two separate pieces of this measurement. Not counted in the length.",
			"reconnectSegment": "Reconnect",
			"changeCable": "Change cable…",
			"finish": "Finish route",
			"segment": "Segment {{index}}",
			"segments": "Segments",
			"deltaH": "Δh",
			"deltaHTooltip": "Vertical distance / installation allowance",
			"unmappedWarning": "Unassigned segments — unmapped meters are not counted",
			"createMeasurement": "Create measurement",
			"selectHint": "Select the cable lines to include, then create the measurement",
			"continueHint": "Click to continue the route · Esc to finish",
			"routing": {
				"title": "Routing",
				"angle": "Angle constraint",
				"angle90": "Orthogonal (90°)",
				"angle45": "Allow 45°",
				"angleFree": "Free",
				"gridRotation": "Grid direction",
				"gridRotationAuto": "Auto",
				"gridRotationInfo": "Grid direction: {{degrees}}°",
				"mode": "Mode",
				"mode_exact": "Exact",
				"mode_angled": "Angled",
				"mode_smart": "Smart",
				"modeHint_exact": "New measurements follow the drawn path exactly.",
				"modeHint_angled": "New measurements are simplified and snapped to the angle grid.",
				"modeHint_smart": "New measurements are simplified like Angled; Calculate route snaps the selected measurement onto confirmed walls and trays.",
				"variantMap": "Cable per guide",
				"variantMapDesc": "Which installation variant of the measurement's cable a leg gets when it runs on a tray or along a wall. Remembered per cable.",
				"variantMap_tray": "Tray",
				"variantMap_wall": "Wall",
				"variantNone": "No cable",
				"variantSingle": "One installation method",
				"guideLayers": "Guide layers",
				"guideLayersDesc": "Drawing layers whose walls and trays Smart routing snaps to on this page. Pick: choose wall or tray, click one line per layer on the drawing, confirm. The eye and focus buttons only change what the drawing shows — hidden layers' guides still route.",
				"guideLayersEmpty": "No guides on this page yet.",
				"useForRouting": "Use for routing",
				"guideHighlights": "Highlight guides on the drawing",
				"isolateGuideLayers": "Show only guide layers",
				"clearGuides": "Clear",
				"clearGuidesDesc": "Remove every guide on this page (undo with Ctrl+Z).",
				"guidesCleared": "{{count}} guides removed",
				"pickKind_wall": "Walls",
				"pickKind_tray": "Trays",
				"pick": "Pick…",
				"pickKindDesc": "What the next pick adds: wall lines or cable trays.",
				"pickStatus_wall": "Picking walls: {{count}} layers",
				"pickStatus_tray": "Picking trays: {{count}} layers",
				"pickHint": "Click one line per layer on the drawing. Every layer under the click is listed — tick the wall or tray layer, untick text and hatch layers. Confirm when done.",
				"pickLayersUnderClick": "Layers under your clicks",
				"pickConfirm": "Add {{count}} layers",
				"snapTolerance": "Search distance",
				"snapToleranceDesc": "How far from the line in the original drawing Smart routing looks for walls and trays. A part of the route within this distance of a guide (and roughly parallel to it) is moved onto the guide. Shown as a band around the selected route.",
				"toleranceBandLabel": "± {{value, number(maximumFractionDigits: 2)}} m",
				"deviationBandLabel": "max {{value, number(maximumFractionDigits: 2)}} m",
				"computing": "Calculating route…",
				"computeError": "Route calculation failed: {{message}}",
				"retry": "Retry",
				"legKinds": "{{onGuide}} of {{total}} legs on guides",
				"detectRunning": "Detecting…",
				"detectEmpty": "No {{kind}} lines found on {{layers}} — pick a line on the wall or tray layer itself (not a text or hatch layer).",
				"detectEmptyKind_wall": "wall",
				"detectEmptyKind_tray": "tray",
				"detectRunningLayers": "Detecting on {{layers}}…",
				"guideStale": "{{count}} outdated — the drawing changed since they were added; clear and pick again.",
				"recorder": "Training cases",
				"recorderDesc": "Developer tool: collect routes for tuning Smart routing. Route an Entry, fix its path until it is the route you want, Add it; Export writes every recorded Entry's current path as the expected route for the harness (bun routing:import). Stored in this browser only.",
				"recorderCount": "{{count}} on this page",
				"recorderAdd": "Add",
				"recorderAddDesc": "Record the selected Entry (its drawn geometry + current path) as a training case.",
				"recorderRemove": "Remove",
				"recorderRemoveDesc": "Forget the selected Entry's training case.",
				"recorderExport": "Export",
				"recorderExportDesc": "Download this page's cases as a routing-export JSON.",
				"recorderClearDesc": "Forget every training case on this page.",
				"recorderNoDrawn": "The selected Entry's drawn geometry is not available on this page — it cannot be recorded.",
				"recorderSkipped": "{{count}} cases skipped: their Entries no longer exist.",
				"guideSelected_wall": "Selected guide: wall",
				"guideSelected_tray": "Selected guide: tray",
				"deleteGuide": "Delete guide",
				"detectUnavailableLayer": "This layer has no stroke data.",
				"detectUnavailablePage": "This drawing has no stroke data.",
				"detectError": "Detection failed: {{message}}",
				"guidesConfirmed": "{{count}} guides added",
				"execute": "Calculate route",
				"preview": "Preview",
				"executeHintNoEntry": "Select a route measurement to re-route it.",
				"modeDesc": "How new distance measurements are routed, and what Calculate route applies to the selected one.",
				"angleDesc": "Allowed leg directions after simplification. In Smart mode this shapes the free legs between guides; legs on a guide follow the guide.",
				"angle90Desc": "Every leg horizontal or vertical on the grid (L-shaped corners).",
				"angle45Desc": "Also allows 45° diagonals (at most one extra bend per leg).",
				"angleFreeDesc": "No snapping — only the tolerance and shortest-segment passes.",
				"gridRotationDesc": "Which direction the angle grid follows: the route itself, the sheet axes, or a line you pick on the drawing.",
				"gridRotationAutoDesc": "Align the grid to the route's own dominant direction (the building's axes).",
				"gridRotationSheet": "Sheet axes",
				"gridRotationSheetDesc": "Align the grid to the sheet's own x/y axes (0°).",
				"gridRotationPick": "Pick from drawing",
				"gridRotationPickDesc": "Click a wall or line on the drawing — the grid follows its direction. Click again to cancel.",
				"gridRotationPicking": "Click a line on the drawing to set the grid direction (Esc cancels).",
				"gridRotationPicked": "Grid direction set to {{degrees}}° from the picked line.",
				"gridRotationPickFailed": "That object has no line direction to follow.",
				"toleranceDesc": "Small wobbles are straightened out: the calculated route may deviate from the line in the original drawing by at most this much. Larger value = fewer corners.",
				"minLengthDesc": "Legs shorter than this are merged into a neighbour when that keeps the angles valid.",
				"tolerance": "Max deviation",
				"minLength": "Shortest segment",
				"lengthDelta": "Length: {{before}} m → {{after}} m ({{signedDelta}} m, {{signedPct}} %)",
				"lengthDeltaNoPct": "Length: {{before}} m → {{after}} m ({{signedDelta}} m)",
				"apply": "Apply",
				"confirm": "Confirm",
				"rerouteConfirm": "This route was hand-edited. Replace it?",
				"droppedWarning": "Segment cables and Δh values were reset. Previous total vertical distance: {{totalDeltaH}} m — re-enter values per segment.",
				"deviation": "Estimated max deviation: {{meters}} m",
				"staleNotice": "Route changed elsewhere — re-run routing.",
				"rerun": "Re-run",
				"noLength": "Route has no measurable length.",
				"noSource": "The drawn geometry behind this route isn't available on this page — open the page it was measured on."
			}
		},
		"grouping": {
			"title": "Selection grouping",
			"granularity": {
				"baked": "Baked",
				"tight": "Tight",
				"medium": "Medium",
				"loose": "Loose"
			},
			"scope": {
				"layer": "This layer",
				"nearby": "Nearby",
				"all": "All layers"
			},
			"auto": "Auto",
			"tuning": "Tuning…",
			"streamGap": "Stream gap",
			"connectGap": "Connect gap",
			"clusterDist": "Cluster dist",
			"autoDist": "Auto dist",
			"autoDistTitle": "Derive Cluster dist per click from the local gap histogram"
		},
		"settings": "Settings",
		"loadingProgress": {
			"title": "Loading Drawing",
			"steps": {
				"download": "Downloading",
				"process": "Processing",
				"render": "Rendering",
				"sync": "Syncing"
			}
		},
		"layerConfig": {
			"title": "Layer configurations",
			"button": "Configurations",
			"name": "Name",
			"namePlaceholder": "Configuration name",
			"description": "Description",
			"descriptionPlaceholder": "Optional notes",
			"setDefault": "Set as default",
			"save": "Save",
			"apply": "Apply",
			"delete": "Delete",
			"default": "Default",
			"empty": "No saved configurations yet.",
			"nameTooShort": "Name must be at least {{min}} characters.",
			"saved": "Configuration saved",
			"saveFailed": "Could not save configuration",
			"deleteFailed": "Could not delete configuration"
		},
		"layerManager": {
			"title": "Layers",
			"titleFiltered": "Layers ({{shown}}/{{total}})",
			"titleAll": "Layers ({{total}})",
			"filterPlaceholder": "Filter layers...",
			"close": "Close layers drawer",
			"showHidden": "Show hidden layers",
			"showLayer": "Show layer",
			"hideLayer": "Hide layer",
			"pinLayer": "Pin layer",
			"unpinLayer": "Unpin layer",
			"lockSelection": "Lock selection",
			"enableSelection": "Enable selection",
			"showAll": "Show all",
			"hideAll": "Hide all",
			"lockAll": "Lock all",
			"unlockAll": "Unlock all",
			"pinAll": "Pin all",
			"unpinAll": "Unpin all",
			"restoreDefaults": "Restore defaults",
			"show": "Show",
			"hide": "Hide",
			"lock": "Lock",
			"unlock": "Unlock",
			"pin": "Pin",
			"unpin": "Unpin",
			"reset": "Reset"
		},
		"classification": {
			"title": "Classification",
			"scheme": "Nomenclature",
			"showAll": "Show all nomenclatures",
			"search": "Search classification",
			"back": "Back",
			"clear": "Clear classification",
			"unclassified": "Unclassified",
			"mixed": "Mixed",
			"system": "System",
			"systemHint": "Optional. Add an identifier (e.g. L.01) to tell apart entries that share this classification.",
			"nodeOnly": "Type only (no concrete system)",
			"createSystem": "Add ID",
			"systemName": "System name",
			"systemTunnus": "Identifier",
			"addSystem": "Add system",
			"usedInTakeoff": "Used in this takeoff",
			"position": "Position",
			"positionMixedPlaceholder": "Mixed — leave unchanged",
			"save": "Save",
			"cancel": "Cancel",
			"selected": "Selected classification",
			"stale": "Outdated classification"
		},
		"preparingSelection": "Preparing selection…",
		"marker": {
			"capReached": "Selection limit reached ({{max}} objects)",
			"belongsToOtherEntry": "Already part of another measurement",
			"alreadySelected": "Already selected – remove it with the Eraser",
			"nothingToErase": "Nothing selected here to remove",
			"outsideFocus": "Focus locked: only focus layers can be selected",
			"outsideFocusRelease": "Release the lock to select from other layers",
			"controls": {
				"toolbar": "Selection tools",
				"marker": "Marker (M)",
				"eraser": "Eraser (E)",
				"undo": "Undo selection (Ctrl+Z)",
				"redo": "Redo selection (Ctrl+Shift+Z)",
				"size": "Size",
				"sizeValue": "{{value}} px",
				"settings": "Dimming",
				"dim": "Dim other layers (D)",
				"dimStrength": "Visibility of dimmed layers",
				"focusLock": "Focus lock (L)",
				"tapScope": "Tap selects (G)",
				"tapScopeSmart": "Smart",
				"tapScopeGroup": "Groups",
				"tapScopeSingle": "Elements",
				"sizeTapOnly": "Size applies to Smart selection"
			}
		},
		"minimap": {
			"label": "Minimap"
		}
	},
	"errors": {
		"invalidTakeoffLink": "Invalid Takeoff link",
		"invalidTakeoffLinkDescription": "The planner link is missing a valid Takeoff id.",
		"invalidDrawingLink": "Drawing not available",
		"invalidDrawingLinkDescription": "This file is not an attached drawing of the Takeoff."
	},
	"packageUpdate": {
		"title_one": "Work package updated",
		"title_other": "Work packages updated",
		"description_one": "{{count}} measurement in this Takeoff uses it. Update it to use the new content?",
		"description_other": "{{count}} measurements in this Takeoff use them. Update them to use the new content?",
		"affected_one": "{{count}} measurement",
		"affected_other": "{{count}} measurements",
		"keepNote": "If you skip this, the measurements keep the content they were made with. You can update them later.",
		"notNow": "Not now",
		"update": "Update measurements"
	}
}
